import { render, staticRenderFns } from "./OverdueRecallList.vue?vue&type=template&id=3004f3bc&scoped=true"
import script from "./OverdueRecallList.vue?vue&type=script&lang=js"
export * from "./OverdueRecallList.vue?vue&type=script&lang=js"
import style0 from "../Followups/list-page.scss?vue&type=style&index=0&id=3004f3bc&prod&lang=scss&scoped=true&external"
import style1 from "./OverdueRecallList.scss?vue&type=style&index=1&id=3004f3bc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3004f3bc",
  null
  
)

export default component.exports